import React from 'react';
export function Footer() {
  return <footer className="bg-dark-950 border-t border-dark-800 py-8 md:py-12" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-189">
        <div className="mb-4 md:mb-8" data-id="element-190">
          <h2 className="text-xl md:text-2xl font-display font-bold text-white mb-1 md:mb-2" data-id="element-191">
            💪 FUNCIONAL & CROSS 360™
          </h2>
          <p className="text-sm md:text-base text-gray-400 max-w-md mx-auto" data-id="element-192">
            El sistema de clases N°1 para profes de funcional y cross training
            en Argentina.
            <br data-id="element-193" />
            <br data-id="element-194" />
            <span className="text-lime-400 font-medium" data-id="element-195">
              Porque enseñar funcional no debería costarte todas las noches de
              la semana.
            </span>
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 md:gap-8 mb-6 md:mb-12 text-xs md:text-sm font-medium text-gray-300" data-id="element-196">
          <a href="mailto:contacto@rincondocente360.com" className="hover:text-lime-400 transition-colors" data-id="element-197">
            📧 contacto@rincondocente360.com
          </a>
          <a href="#" className="hover:text-lime-400 transition-colors" data-id="element-198">
            📲 @rincondocente360
          </a>
          <a href="#" className="hover:text-lime-400 transition-colors" data-id="element-199">
            🌐 funcional.rincondocente360.com
          </a>
        </div>

        <div className="text-xs text-gray-600 space-y-2" data-id="element-200">
          <p data-id="element-201">© RinconDocente360™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-202">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}